/**
 * Contact page data: team members and contact information
 */

export const contactInfo = {
  address: 'Sector 75, Noida, Uttar Pradesh, India',
  email: 'info@webishatech.com',
  phone: '+91 9845751461',
  hours: 'Monday - Saturday: 9:00 AM - 10:00 PM',
};

export const contactTeamMembers = [
  { name: 'Sean Miller', location: 'Seattle', role: 'CCO' },
  { name: 'Jane Anderson', location: 'Seattle', role: 'CTO' },
  { name: 'Emily Chen', location: '', role: 'Lead Developer' },
  { name: 'David Johnson', location: '', role: 'Senior Solutions Architect' },
];
